<nav class="bg-white dark:bg-gray-900 w-full">
  <div class="w-full flex flex-wrap items-center justify-between mx-auto py-4">
    <div class="items-center">
      @if (isSearchBarVisible()) {
        <div class="ml-5 w-[0px] md:w-[430px] lg:w-[500px] xl:w-[500px]">
          <p-inputgroup class="h-[40px]" (click)="menu.toggle($event)" >
            <p-inputgroup-addon>
              <i class="uil uil-search"></i>
            </p-inputgroup-addon>
            <input
              pInputText
              [(ngModel)]="inputText"
              (keyup.enter)="setBoardFilter()"
              [placeholder]="translateKey.PLACEHOLDER_SEARCH | translate"
            />
          </p-inputgroup>
          <p-menu #menu [popup]="true" appendTo="body">
            <ng-template pTemplate="start">
              <div class="p-4 mt-2">{{ translateKey.BOARD_SCORING_ALGO_FILTER | translate }}</div>
              <div class="flex flex-row justify-between gap-4 w-full p-4">
                <p-floatlabel variant="on">
                  <p-inputnumber [showButtons]="true"[min]="0"
                    inputId="input_number_application_value" mode="decimal" [(ngModel)]="strictLimiter"/>
                  <label for="input_number_application_value">{{ translateKey.BOARD_FILTER_NUMBER_OF_APPLICATIONS | translate }}</label>
                </p-floatlabel>
                <p-floatlabel variant="on" class="w-full">
                  <p-select class="w-full" [options]="percentagesOptions" [(ngModel)]="limitFilter" optionLabel="label" optionValue="value" id="percentage"/>
                  <label for="percentage">{{ translateKey.BOARD_FILTER_PERCENTAGE | translate }}</label>
                </p-floatlabel>
              </div>
              <div class="w-full">
                <p-floatlabel class="p-4 mt-4 w-[50%]" variant="on">
                  <p-select class="w-full" [options]="directionsOptions" [(ngModel)]="directionFilter" optionLabel="label" optionValue="value" id="direction"/>
                  <label for="direction">{{ translateKey.BOARD_FILTER_DIRECTION | translate }}</label>
                </p-floatlabel>
              </div>
              @if (job) {
              <div class="flex flex-col gap-4 p-4 w-[500px] max-h-[400px] overflow-y-auto">
                @for (item of filteredInfosAdditionals; track $index; let i = $index) {
                  @if (item.type === infosAddsType.INPUT_NUMBER) {
                    <div class="flex flex-col gap-2">
                      <span>{{ item.title }}</span>
                      <div (click)="$event.stopPropagation()" class="flex flex-row justify-between gap-2 w-full">
                        <p-floatlabel variant="on" class="w-full">
                          <p-select
                            id="input_number_interval"
                            class="w-full !border-[#ccc]"
                            [options]="dropdownOptions"
                            optionLabel="label"
                            optionValue="value"
                            showClear="true"
                            [(ngModel)]="inputNumberIntervalFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_NUMBER)]">
                          </p-select>
                          <label for="input_number_interval">{{ translateKey.BOARD_FILTER_SET_INTERVAL | translate }}</label>
                        </p-floatlabel>
                        <p-floatlabel variant="on" class="w-full">
                          <p-inputnumber [showButtons]="true" class="w-full" [min]="0"
                            inputId="input_number_value" mode="decimal" [(ngModel)]="inputNumberFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_NUMBER)]"/>
                          <label for="input_number_value">{{ translateKey.BOARD_FILTER_SET_VALUE | translate }}</label>
                        </p-floatlabel>
                      </div>
                    </div>
                  }
                  @if (item.type === infosAddsType.INPUT_RADIO) {
                    <div class="flex flex-col gap-2 mt-4">
                      <span>{{ item.title }}</span>
                      <div (click)="$event.stopPropagation()" class="w-full">
                        <p-multiselect
                          [id]="item.type+i"
                          class="w-full !border-[#ccc]"
                          [options]="setMultipleValueOption(returnInfosAddValue(item.value, item.type))"
                          optionLabel="label" optionValue="value"
                          [(ngModel)]="inputRadioFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_RADIO)]" [maxSelectedLabels]="5">
                        </p-multiselect>
                      </div>
                    </div>
                  }
                  @if (item.type === infosAddsType.INPUT_CHECKBOX) {
                    <div class="flex flex-col gap-2 mt-4">
                      <span>{{ item.title }}</span>
                      <div (click)="$event.stopPropagation()" class="w-full">
                        <p-multiselect
                          [id]="item.type+i"
                          class="w-full !border-[#ccc]"
                          [options]="setMultipleValueOption(returnInfosAddValue(item.value, item.type))"
                          optionLabel="label" optionValue="value"
                          [(ngModel)]="inputCheckBoxFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_CHECKBOX)]" [maxSelectedLabels]="5">
                        </p-multiselect>
                      </div>
                    </div>
                  }
                  @if (item.type === infosAddsType.INPUT_SELECT) {
                    <div class="flex flex-col gap-2 mt-4">
                      <span>{{ item.title }}</span>
                      <div (click)="$event.stopPropagation()" class="w-full">
                        <p-multiselect
                          [id]="item.type+i"
                          class="w-full !border-[#ccc]"
                          [options]="setMultipleValueOption(returnInfosAddValue(item.value, item.type))"
                          optionLabel="label" optionValue="value"
                          [(ngModel)]="inputSelectFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_SELECT)]" [maxSelectedLabels]="5">
                        </p-multiselect>
                      </div>
                    </div>
                  }
                  @if (item.type === infosAddsType.INPUT_DATE) {
                    <div class="flex flex-col gap-2 mt-4">
                      <span>{{ item.title }}</span>
                      <div class="flex flex-row justify-between gap-2">
                        <p-datepicker class="w-full" showClear="true" [placeholder]="translateKey.BOARD_FILTER_SET_START_DATE | translate"
                        id="inputStartDate" pInputText [(ngModel)]="inputStartDateFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_DATE)]" [iconDisplay]="'input'"
                        [showIcon]="true" inputId="inputStartDate" />
                        <p-datepicker class="w-full" showClear="true" [placeholder]="translateKey.BOARD_FILTER_SET_END_DATE | translate"
                        id="inputEndDate" pInputText [(ngModel)]="inputEndDateFilter[getTitleIndex(item.sequence, infosAddsType.INPUT_DATE)]" [iconDisplay]="'input'"
                        [showIcon]="true" inputId="inputEndDate" />
                      </div>
                    </div>
                  }
                }
                <div class="flex justify-between mt-8">
                  <button type="button" pButton class="form-cancel-button" icon="uil uil-times" pRipple
                    [label]="translateKey.CONFIRMATION_MODAL_CANCEL_BUTTON | translate" (click)="resetBoardSearch();menu.toggle($event)"> </button>
                  <p-button type="button" icon="uil uil-check" pRipple
                    [label]="translateKey.FORM_SAVE_BUTTON_LABEL | translate"
                    (click)="setBoardFilter();menu.toggle($event)"/>
                </div>
              </div>
            }
            </ng-template>
        </p-menu>
        </div>
      }
    </div>
  </div>
</nav>

